<section class="finding-input-wrapper" [ngClass]="{'value-changed':changed?.value,'level-changed':changed?.level}">
  <gen-dynamic-form
    [formConfig]="formConfig.inputs"
    (validateChange)="updateValidation($event)"
    (formInit)="updateValues({form:$event})"
    (formChange)="updateValues($event)"
    [formData]="valueObject"
    [disabled]="!editable ||changed"
    [editMode]="!editable">
  </gen-dynamic-form>
</section>

